/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { observer, inject } from 'mobx-react';
import { ImagedSection as ImagedSectionModel } from 'models';
import { Row, Column } from 'hedron';
import Container from 'blocks/Container/Container';
import { media } from 'designsystem/index';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import ds from 'designsystem';
import { FADE_VALUES, parallaxImage, scaleImage } from 'animations/Animations';
import HTMLParser from 'blocks/Parser/Parser';
import { Bind } from 'lodash-decorators';
import Header2 from 'elements/Header2';
import Paragraph from 'elements/Paragraph';
import DescriptionText from 'elements/DescriptionText';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { safeHtmlWithBr } from 'common/methods/string';
import Image from './Image';

const ImagedSection = styled.div`
    ${media.desktop`
      padding: ${ds.get('metrics.l')} 0;
      padding-bottom: 0;
    `};
`;

const Description = DescriptionText.extend`
  & > ${Paragraph} {
    font-size: ${ds.fs('m')};
    line-height: ${ds.get('type.lineHeight.m')};
    font-weight: ${ds.get('type.fontWeight.regular')};
    font-family: Roboto;

    ${media.tablet`
      font-size: ${ds.fs('l')};
      line-height: ${ds.get('type.lineHeight.l')};
    `}
  }
`;

const ImagedSectionHeader = Header2.extend`
    font-size: ${ds.fs('l')};
    line-height: ${ds.get('type.lineHeight.l')};
    
    ${media.tablet`
      font-size: ${ds.fs('xl')};
      line-height: ${ds.get('type.lineHeight.xl')};
    `}
`;

const backgroundStyles = {
  overflow: 'hidden',
};

const leftColumnStyles = {
  alignSelf: 'flex-end',
};

const rightColumnStyles = {
  paddingRight: 0,
};

ImagedSection.Image = Image;

@inject("windowStore")
@observer
export default class ImagedSectionBlock extends Component {
  static propTypes = {
    data: PropTypes.instanceOf(ImagedSectionModel).isRequired,
  }

  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
  }

  componentDidMount() {
    const { windowStore } = this.props;
    this.disposeOnScroll = windowStore.reactToScroll(this.onScroll);
  }

  componentWillUnmount() {
    this.disposeOnScroll();
  }

  @Bind
  onScroll() {
    scaleImage(this.elementRef.current, 1.1, 0.8);
    parallaxImage(this.elementRef.current, 100, -100, 10);
  }

  render() {
    const {
      data: {
        header,
        text,
        image,
        htmlModifiers,
      },
      windowStore,
    } = this.props;

    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('white')}
        style={backgroundStyles}
      >
        <Container>
          <ImagedSection>
            <Row alignItems="flex-start">
              <Column
                lg={7}
                style={leftColumnStyles}
              >
                <Fade
                  distance={`${FADE_VALUES.TEXT.SMALL}`}
                  delay={FADE_VALUES.DELAY.SMALL}
                  bottom
                >
                  <ImagedSectionHeader
                    dangerouslySetInnerHTML={{ __html: safeHtmlWithBr(header.text) }}
                  />
                  <Description>
                    <HTMLParser
                      htmlBody={text}
                    />
                  </Description>
                </Fade>
              </Column>
              <Column
                lg={5}
                style={rightColumnStyles}
              >
                <ImagedSection.Image
                  src={windowStore.adjustImageSize(image)}
                  innerRef={this.elementRef}
                />
              </Column>
            </Row>
          </ImagedSection>
        </Container>
      </HTMLModifiableBackground>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImagedSection/index.jsx